import { render } from "./TargetProductGroupAdmin.vue?vue&type=template&id=18fcdae8"
import script from "./TargetProductGroupAdmin.vue?vue&type=script&lang=js"
export * from "./TargetProductGroupAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__